// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3865":"05c345f3","8412":"0dfde970","8549":"6fe069ba"}[chunkId] + ".chunk.css";
};